import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { onApiCallPropertyList } from "../../Core/Apicall";
import { UrlImage } from "../../Core/ApiEndPoint";
import { useTranslation } from "react-i18next";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import PriceFilter from "../../Components/CommonPricefilter/CommonPricefilter";
import "./ApartmentCards.css";

export function PropertiesCard({ multiple_images, address, title, bathrooms, bedrooms, type, id, price_monthly_up, price_monthly_down }) {

    const navigator = useNavigate();
    const formatPrice = (value) => {
        if (!value) return "";
        return Number(value).toLocaleString("en-US");
    };
    const { t } = useTranslation();
    const { i18n } = useTranslation();

    const lang = i18n.language;
    const [loadedImages, setLoadedImages] = useState({});
    const [imageUrls, setImageUrls] = useState({});

    const handleImageLoad = (index) => {
        setLoadedImages((prev) => ({ ...prev, [index]: true }));
    };

    useEffect(() => {
        if (!multiple_images) return;

        multiple_images.slice(0, 6).forEach((img, index) => {
            const image = new Image();

            image.src = UrlImage + img;

            image.onload = () => {
                setImageUrls(prev => ({
                    ...prev,
                    [index]: image.src,
                }));

                setLoadedImages(prev => ({
                    ...prev,
                    [index]: true,
                }));
            };
        });
    }, [multiple_images]);
    return (
        <div className="card">
            <div className="card-image-wrapper"
            >
                <Swiper
                    style={{ height: "100%", zIndex: "1" }}
                    slidesPerView={1}
                    spaceBetween={16}
                    navigation
                    pagination={{ clickable: true }}
                    loop={true}

                    autoplay={{
                        delay: 5000,   // 3 seconds
                        disableOnInteraction: false,
                    }}
                    modules={[Navigation, Pagination, Autoplay]}
                    breakpoints={{
                        640: { slidesPerView: 1 },
                        960: { slidesPerView: 1 },
                    }}
                >
                    {multiple_images && multiple_images.slice(0, 6).map((img, index) => (
                        <SwiperSlide key={index}>
                            {!loadedImages[index] && (
                                <div className="card-image-skeleton">
                                    <span className="card-image-spinner"></span>
                                </div>
                            )}

                            {loadedImages[index] && (
                                <img
                                    className="card-image"
                                    src={imageUrls[index]}
                                    alt={title}
                                    onClick={() =>
                                        navigator(`/properties/properties-details/${id}?lang=${lang}`)
                                    }
                                />
                            )}
                        </SwiperSlide>
                    ))}

                </Swiper>


            </div>

            <div className="card-body">
                <div className="price-box">
                    {/* <span className="from">{t("from")}</span> */}
                    <span className="price">
                        {price_monthly_up ? (
                            price_monthly_down && Number(price_monthly_down) !== 0 ? (
                                `$${formatPrice(price_monthly_down)}-$${formatPrice(price_monthly_up)}`
                            ) : (
                                `$${formatPrice(price_monthly_up)}+`
                            )
                        ) : (
                            ""
                        )}</span>
                    {/* <span className="per">/ {t("month")}</span> */}
                </div>
                <div className="card-info ">
                    {address}
                </div>


                <h3 className="card-title">{title}</h3>
                <div className="card-info flex items-center gap-2 card-info-icons">
                    <span>
                        <i className="fa-solid fa-bed mr-1"></i>
                        {bedrooms} {t("Bedrooms")}
                    </span>
                    <span></span>
                    <span>
                        <i className="fa-solid fa-bath mr-1"></i>
                        {bathrooms} {t("Baths")}
                    </span>
                </div>


                <div className="card-footer">

                    <button onClick={() => navigator(`/properties/properties-details/${id}?lang=${lang}`)} >See Details</button>
                </div>
            </div>
        </div>
    );
}

export default function Properties() {
    const { i18n, t } = useTranslation();

    const bedroomOptions = [(t("Studio")), "1", "2", "3", "4+"];
    const bathroomOptions = ["1", "2", "3", "4", "5+"];

    const [selectedBedrooms, setSelectedBedrooms] = useState([""]);
    const [selectedBathrooms, setSelectedBathrooms] = useState([""]);

    const [profileData, setProfileData] = useState([]);
    const [priceRange, setPriceRange] = useState({
        min: 0,
        max: 10000
    });
    const [search, setSearch] = useState("");
    const lang = i18n.language;
    const [page, setPage] = useState(1);
    const [openFilter, setOpenFilter] = useState(false);
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(10000);

    const [dogsAllowed, setDogsAllowed] = useState(false);
    const [noBreedRestrictions, setNoBreedRestrictions] = useState(false);
    const [catsAllowed, setCatsAllowed] = useState(false);

    const [petsPopup, setPetsPopup] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);

    const [address, setAddress] = useState("");
    const [profileDataSearch, setProfileDataSearch] = useState([]);
    const [selectedLocations, setSelectedLocations] = useState([]);

    const locations = [
        ...new Set(profileDataSearch?.map((item) => item.neighborhood))
    ];

    const filteredLocations = locations.filter((item) =>
        (item || "").toLowerCase().includes((search || "").toLowerCase())
    );

    const mapOptionValue = (value) => {
        if (value === "Studio") return 0;
        if (value === "4+") return 4;
        if (value === "5+") return 5;
        return Number(value);
    };

    const getRangeValues = (selectedValues) => {
        if (!selectedValues || selectedValues.length === 0) {
            return { min: "", max: "" };
        }

        const numericValues = selectedValues
            .map(mapOptionValue)
            .sort((a, b) => a - b);

        return {
            min: numericValues[0],
            max: numericValues[numericValues.length - 1],
        };
    };
    const handleApiCallPropertyList = async (pageNumber = page) => {
        try {

            const bedroomRange = getRangeValues(selectedBedrooms);
            const bathroomRange = getRangeValues(selectedBathrooms);

            const params = `/?lang=${lang}&page=${pageNumber}&per_page=12`;
            const response = await onApiCallPropertyList(
                {
                    // property_type: propertyType,
                    title: selectedLocations,
                    min_price: minPrice,
                    max_price: maxPrice,
                    bedrooms_min: bedroomRange.min === 0 ? "" : bedroomRange.min || "",
                    bedrooms_max: bedroomRange.max === 0 ? "" : bedroomRange.max || "",
                    bathrooms_min: bathroomRange.min === 0 ? "" : bathroomRange.min || "",
                    bathrooms_max: bathroomRange.max === 0 ? "" : bathroomRange.max || "",
                    dogs_allowed: dogsAllowed ? 1 : "",
                    no_breed_restrictions: noBreedRestrictions ? 1 : "",
                    cats_allowed: catsAllowed ? 1 : "",
                },
                params
            );

            setProfileData(response);
            setPage(pageNumber); // update current page
            console.log("res", response);

        } catch (err) {
            console.error("Error fetching property list:", err);
        }
    };

    const handleApiCallPropertySearch = async () => {
        try {
            const params = `/?lang=${lang}&per_page=300`;
            const response = await onApiCallPropertyList({ search: "" }, params);

            setProfileDataSearch(response.data);
            console.log("Res Search", response);
        } catch (err) {
            console.error("Error fetching property list:", err);
        }
    };

    // Call API on component mount
    useEffect(() => {
        setPage(1);
        handleApiCallPropertyList(1);
        handleApiCallPropertySearch();

    }, [lang, priceRange]);


    useEffect(() => {
        const delay = setTimeout(() => {
            setPage(1);
            handleApiCallPropertyList(1);
        }, 1000);

        return () => clearTimeout(delay);
    }, [address, selectedBedrooms, selectedBathrooms, minPrice, maxPrice, dogsAllowed, noBreedRestrictions, catsAllowed, selectedLocations]);


    const handleRangeSelect = (value, options, selectedValues, setSelectedValues) => {
        if (selectedValues.length === 0) {
            setSelectedValues([value]);
            return;
        }

        if (selectedValues.length === 1 && selectedValues.includes(value)) {
            setSelectedValues([]);
            return;
        }

        const sortedIndexes = selectedValues
            .map((item) => options.indexOf(item))
            .sort((a, b) => a - b);

        const currentMin = sortedIndexes[0];
        const currentMax = sortedIndexes[sortedIndexes.length - 1];
        const clickedIndex = options.indexOf(value);

        // if clicked inside current range, reset from clicked point
        if (clickedIndex >= currentMin && clickedIndex <= currentMax) {
            setSelectedValues([value]);
            return;
        }

        const start = Math.min(currentMin, clickedIndex);
        const end = Math.max(currentMax, clickedIndex);

        const range = options.slice(start, end + 1);
        setSelectedValues(range);
    };
    const getPillClass = (options, selectedValues, item, index) => {
        const isActive = selectedValues.includes(item);
        if (!isActive) return "";

        const prevItem = options[index - 1];
        const nextItem = options[index + 1];

        const prevActive = selectedValues.includes(prevItem);
        const nextActive = selectedValues.includes(nextItem);

        if (!prevActive && !nextActive) return "active single";
        if (!prevActive && nextActive) return "active start";
        if (prevActive && nextActive) return "active middle";
        if (prevActive && !nextActive) return "active end";

        return "active";
    };

    const handleClear = () => {
        setDogsAllowed(false);
        setNoBreedRestrictions(false);
        setCatsAllowed(false);
    };

    const handleCheckboxChange = (location) => {
        if (selectedLocations.includes(location)) {
            setSelectedLocations(selectedLocations.filter((item) => item !== location));
        } else {
            setSelectedLocations([...selectedLocations, location]);
        }

        setSearch(""); // 👈 reset search so selected values show
    };
    const isAllSelected =
        filteredLocations.length > 0 &&
        filteredLocations.every((item) => selectedLocations.includes(item));

    const handleSelectAll = () => {
        if (isAllSelected) {
            // remove all filtered
            setSelectedLocations(
                selectedLocations.filter((item) => !filteredLocations.includes(item))
            );
        } else {
            // add all filtered (avoid duplicates)
            const newItems = filteredLocations.filter(
                (item) => !selectedLocations.includes(item)
            );
            setSelectedLocations([...selectedLocations, ...newItems]);
        }
    };

    const handleRemoveLocation = (item) => {
        setSelectedLocations(selectedLocations.filter((loc) => loc !== item));
    };


    return (
        <div className="page">

            <div className="container" >
                <h1 style={{ color: "#295d85", fontWeight: "700" }} >{t("Properties For Rent")}</h1>

                <div style={{ display: "flex", gap: 12, flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", marginBottom: 20, paddingLeft: "10px" }}>



                    <div style={{
                        display: "flex",
                        gap: 12,
                        flexWrap: "wrap",
                        padding: "10px 0px"
                    }}>
                        <div className="search-wrapper serch-dropdown-wrapper" onMouseLeave={() => setShowDropdown(false)}>
                            <div className="search-box">

                                <div className="input-chip-container" onClick={() => setShowDropdown(true)}>

                                    {/* ✅ Selected Chips */}
                                    {selectedLocations.map((item, index) => (
                                        <div key={index} className="chip">
                                            {item}
                                            <span
                                                className="chip-close"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleRemoveLocation(item);
                                                }}
                                            >
                                                ✕
                                            </span>
                                        </div>
                                    ))}

                                    {/* ✅ Input */}
                                    <input
                                        type="text"
                                        value={search}
                                        onChange={(e) => {
                                            setSearch(e.target.value);
                                            setShowDropdown(true);
                                        }}
                                        placeholder="Select Locations..."
                                        className="chip-input"
                                    />
                                </div>

                                {showDropdown && (
                                    <div className="dropdown-list">

                                        {/* ✅ Select All */}
                                        <label style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                            padding: "10px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #f1f1f1"
                                        }} className="dropdown-item">
                                            <input
                                                type="checkbox"
                                                checked={isAllSelected}
                                                onChange={handleSelectAll}
                                            />
                                            <strong>Select All</strong>
                                        </label>

                                        {/* ✅ List */}
                                        {filteredLocations.map((item, index) => (
                                            <label style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px",
                                                padding: "10px",
                                                cursor: "pointer",
                                                borderBottom: "1px solid #f1f1f1"
                                            }} key={index} className="dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedLocations.includes(item)}
                                                    onChange={() => handleCheckboxChange(item)}
                                                />
                                                {item}
                                            </label>
                                        ))}
                                    </div>
                                )}

                            </div>
                        </div>

                        {/* 
                        <div>
                            <CustomDropdown
                                className="custom-dropdown"
                                options={[
                                    { value: "Apartment", label: "Apartment" },
                                    { value: "Room in Co-Living", label: "Room in Co-Living" },
                                    { value: "Student Residence", label: "Student Residence" }
                                ]}
                                value={propertyType}
                                onChange={setPropertyType}
                                placeholder="Categories"
                            />
                        </div>
                         */}

                        <div >
                            <PriceFilter
                                onChange={(range) => {
                                    setPriceRange(range);
                                }}
                                minPrice={minPrice}
                                maxPrice={maxPrice}
                                setMinPrice={setMinPrice}
                                setMaxPrice={setMaxPrice}
                                totalCount={profileData?.pagination?.total}
                            />
                        </div>

                        <div onMouseLeave={() => setOpenFilter(false)} >
                            <div className="bedrooms-dropdown" onClick={() => setOpenFilter((prev) => !prev)}>
                                {t("Beds/Baths")}
                                <span className="cd-caret">
                                    {openFilter ? (
                                        <i className="fa">&#xf106;</i>
                                    ) : (
                                        <i className="fa">&#xf107;</i>
                                    )}
                                </span>
                            </div>
                            <div
                                className="filter-card bedrooms-dropdown-filter"
                                style={{ display: openFilter ? "block" : "none" }}
                            >
                                <div className="filter-section">
                                    {/* <div className="box-show-hidden" onClick={() => setOpenFilter(false)}></div> */}
                                    <h3> {t("Bedrooms")}</h3>
                                    <div className="pill-group">
                                        {bedroomOptions.map((item, index) => (
                                            <button
                                                key={item}
                                                className={`pill-btn ${getPillClass(
                                                    bedroomOptions,
                                                    selectedBedrooms,
                                                    item,
                                                    index
                                                )}`}
                                                onClick={() =>
                                                    handleRangeSelect(
                                                        item,
                                                        bedroomOptions,
                                                        selectedBedrooms,
                                                        setSelectedBedrooms
                                                    )
                                                }
                                            >
                                                {item}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <div className="filter-section">
                                    <h3>{t("Bathrooms")}</h3>
                                    <div className="pill-group">
                                        {bathroomOptions.map((item, index) => (
                                            <button
                                                key={item}
                                                className={`pill-btn ${getPillClass(
                                                    bathroomOptions,
                                                    selectedBathrooms,
                                                    item,
                                                    index
                                                )}`}
                                                onClick={() =>
                                                    handleRangeSelect(
                                                        item,
                                                        bathroomOptions,
                                                        selectedBathrooms,
                                                        setSelectedBathrooms
                                                    )
                                                }
                                            >
                                                {item}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <div className="filter-footer">
                                    <button
                                        className="clear-btn"
                                        onClick={() => {
                                            setSelectedBedrooms([]);
                                            setSelectedBathrooms([]);
                                        }}
                                    >
                                        {t("Clear")}
                                    </button>

                                    <button onClick={() => setOpenFilter((prev) => !prev)} className="result-btn">{t("View")} {profileData?.pagination?.total} {t("results")}</button>
                                </div>
                            </div>
                        </div>

                        <div onMouseLeave={() => setPetsPopup(false)} >
                            <div className="bedrooms-dropdown" onClick={() => setPetsPopup((prev) => !prev)}>
                                {t("Pets")}
                                <span className="cd-caret">
                                    {petsPopup ? (
                                        <i className="fa">&#xf106;</i>   // 🔼 up arrow
                                    ) : (
                                        <i className="fa">&#xf107;</i>   // 🔽 down arrow
                                    )}
                                </span>
                            </div>
                            <div className="filter-card pets-dropdown-filter" style={{ display: petsPopup ? "block" : "none" }}>
                                {/* <div className="box-show-hidden" onClick={() => setPetsPopup(false)}></div> */}

                                <label className="check-row active">
                                    <input
                                        type="checkbox"
                                        checked={dogsAllowed}
                                        onChange={() => setDogsAllowed(!dogsAllowed)}
                                    />
                                    <span className="custom-checkbox"></span>
                                    <span className="label-text"> {t("Dogs allowed")}</span>
                                </label>
                                {dogsAllowed && (
                                    <label className="check-row" style={{ marginLeft: "32px" }}>
                                        <input
                                            type="checkbox"
                                            checked={noBreedRestrictions}
                                            onChange={() => setNoBreedRestrictions(!noBreedRestrictions)}
                                        />
                                        <span className="custom-checkbox"></span>
                                        <span className="label-text"> {t("No breed restrictions")}</span>
                                    </label>)}

                                <label className="check-row active">
                                    <input
                                        type="checkbox"
                                        checked={catsAllowed}
                                        onChange={() => setCatsAllowed(!catsAllowed)}
                                    />
                                    <span className="custom-checkbox"></span>
                                    <span className="label-text"> {t("Cats allowed")}</span>
                                </label>

                                <div className="filter-footer pets-filter-footer">
                                    <button className="clear-btn" onClick={handleClear}>
                                        {t("Clear")}
                                    </button>

                                    <button className="result-btn" onClick={() => setPetsPopup((prev) => !prev)} >
                                        {t("View")} {profileData?.pagination?.total} {t("results")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                    {profileData?.data?.length === 0 ? (
                        <p style={{ textAlign: "center", padding: "20px" }}>
                            No data found
                        </p>
                    )
                        : <>

                            {profileData?.data?.map((item, i) => (

                                <PropertiesCard key={i} {...item} />

                            ))}

                        </>}
                </div>
                <div className="total-flex">
                    {profileData?.pagination?.total > 0 && (
                        <div className="total-results">
                            {t("Showing")} {profileData?.data?.length} of {profileData?.pagination?.total} {t("properties")}
                        </div>
                    )}
                    <div className="pagination">
                        <button
                            disabled={page === 1}
                            onClick={() => handleApiCallPropertyList(page - 1)}
                        >
                            {/* Left arrow SVG */}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                className="arrow"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>

                        </button>

                        <span className="page-info">
                            Page {profileData?.pagination?.current_page} {t("of")} {profileData?.pagination?.last_page}
                        </span>

                        <button
                            disabled={page === profileData?.pagination?.last_page}
                            onClick={() => handleApiCallPropertyList(page + 1)}
                        >

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                className="arrow"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div >
    );
}
